import React, { useEffect } from "react";
import LoadingOverlay from "react-loading-overlay";
import { shallowEqual, useSelector } from "react-redux";

export function CommonLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.loading.isLoading }),
    shallowEqual
  );
  useEffect(() => {
    //console.log(isLoading);
  }, [isLoading]);

  return (
    <LoadingOverlay
      active={isLoading}
      spinner
      styles={{
        overlay: (base) => ({
          ...base,
          background: "#E4E6EF",
          opacity: 0.5,
          color: "#000",
          position: "fixed",
          zIndex: 1100,
        }),
        spinner: (base) => ({
          ...base,
          width: "100px",
          "& svg circle": {
            stroke: "#000",
          },
        }),
      }}
    ></LoadingOverlay>
  );
}
